import { Geometry } from '@highimpact-frontend/map-geometry';
import L from 'leaflet';
import { useEffect } from 'react';
import { useMap } from 'react-leaflet';

interface LeafletFitBoundsProps {
  geometries: Geometry<number, number>[];
}

/**
 * Center map instance on markers props bounds.
 * Located insid a MapCountainer.
 */
function LeafletFitBounds({ geometries }: LeafletFitBoundsProps) {
  // Map instance of MapCountainer. @see: https://react-leaflet.js.org/docs/api-map/.
  const map = useMap();

  // On map or markers changes.
  useEffect(() => {
    if (geometries.length === 0) return;

    const allCoords: [number, number][] = [];
    // FIXEME: To check if we get only the site perimeter
    geometries.forEach((geometry) => {
      if (geometry && geometry !== null)
        switch (geometry.type) {
          case 'POINT':
            allCoords.push(geometry.coordinates as [number, number]);
            break;
          case 'POLYGON':
            geometry.coordinates.forEach((node) => {
              allCoords.push(node);
            });
            break;
          default:
            console.warn(`Unsupported geometry type: ${geometry.type}`);
        }
    });

    if (allCoords.length > 0) {
      const bounds = L.latLngBounds(allCoords);
      map.fitBounds(bounds, { maxZoom: 15 });
    }
  }, [map, geometries]);

  return null;
}

export default LeafletFitBounds;
